/* Lotte Laren — kortingspercentage (-60%) op alle productkaarten van het thema.
   Berekend uit de oude en nieuwe prijs op de kaart; werkt ook na filteren/sorteren. */
(function () {
  function toNumber(text) {
    var m = String(text || '').match(/\d[\d.\s]*,\d{2}|\d[\d,\s]*\.\d{2}|\d+/);
    if (!m) return NaN;
    var s = m[0].replace(/\s/g, '');
    if (/,\d{2}$/.test(s)) s = s.replace(/\./g, '').replace(',', '.');
    else s = s.replace(/,/g, '');
    return parseFloat(s);
  }

  function decorate(card) {
    if (card.__llOff) return;
    var price = card.querySelector('.price.sale');
    var img = card.querySelector('.product-item__image');
    if (!price || !img) return;
    var now = toNumber((price.querySelector('.new-price') || {}).textContent);
    var was = toNumber((price.querySelector('.old-price') || {}).textContent);
    if (!(was > now) || !(now > 0)) return;
    var pct = Math.round((was - now) / was * 100);
    if (pct < 1) return;
    card.__llOff = true;
    var badge = document.createElement('span');
    badge.className = 'll-grid-off';
    badge.textContent = '-' + pct + '%';
    img.appendChild(badge);
  }

  function run(scope) {
    (scope || document).querySelectorAll('.product-item').forEach(decorate);
  }

  function start() {
    run();
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; run(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* Lotte Laren — bolinhas (dots) onder de mobiele slider met voordelen, zoals Sara Amsterdam */
(function () {
  var css = document.createElement('style');
  css.textContent =
    '.ll-dots{display:none}' +
    '@media (max-width:749px){' +
    '.ll-dots{display:flex;justify-content:center;gap:10px;margin:18px 0 0;padding:0;list-style:none}' +
    '.ll-dots button{width:9px;height:9px;padding:0;border:0;border-radius:50%;background:rgba(74,50,34,.25);cursor:pointer;transition:background .2s,transform .2s}' +
    '.ll-dots button.is-active{background:#4a3222;transform:scale(1.15)}}';
  document.head.appendChild(css);

  function setup(grid) {
    if (grid.__llDots) return;
    var items = grid.querySelectorAll(':scope > .grid-item');
    if (items.length < 2) return;
    grid.__llDots = true;
    var dots = document.createElement('ul');
    dots.className = 'll-dots';
    items.forEach(function (item, i) {
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Ga naar ' + (i + 1));
      b.addEventListener('click', function () {
        grid.scrollTo({ left: item.offsetLeft - grid.offsetLeft, behavior: 'smooth' });
      });
      li.appendChild(b);
      dots.appendChild(li);
    });
    grid.insertAdjacentElement('afterend', dots);
    var btns = dots.querySelectorAll('button');
    function update() {
      var w = items[0].offsetWidth || 1;
      var i = Math.round(grid.scrollLeft / w);
      i = Math.max(0, Math.min(btns.length - 1, i));
      btns.forEach(function (b, n) { b.classList.toggle('is-active', n === i); });
    }
    grid.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    update();
  }

  function run() {
    document.querySelectorAll('.section-columns .grid--mobile-slider').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

/* Lotte Laren — productnamen altijd als "Naam | Omschrijving".
   Nieuwe producten met "Naam - Omschrijving" of "Naam – Omschrijving" worden automatisch
   met een streep getoond (productpagina, kaarten, winkelwagen, zoekresultaten). */
(function () {
  var SEL = '.product__title, .product-item__title, .ll-card__title, .cart__item__title, .cart-item__title, .ll-sr__title, [class*="product"] [class*="title"], [class*="cart"] [class*="title"]';
  var RE = /^([^|\-–]{1,40}?)\s+[-–]\s+/;
  function fixNode(el) {
    if (el.__llTitle) return;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var n = walker.nextNode();
    while (n && !n.nodeValue.trim()) n = walker.nextNode();
    if (!n) return;
    var v = n.nodeValue;
    var lead = v.match(/^\s*/)[0];
    var t = v.slice(lead.length);
    if (RE.test(t)) n.nodeValue = lead + t.replace(RE, '$1 | ');
    el.__llTitle = true;
  }
  function run() {
    document.querySelectorAll(SEL).forEach(function (el) {
      if (el.closest('header, footer, .drawer--header, .collection__sidebar')) return;
      fixNode(el);
    });
  }
  function start() {
    run();
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; run(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
